export default "__VITE_ASSET__D0bXRxOL__ 800w, __VITE_ASSET__CfOiSRsc__ 1120w";